import { BlockedRecordBlockedType } from '@exam-center/graphql';

import { useBlockedRecordDetails } from '../../providers';
import { BlockedCheaterReadonlyDetails } from '../blocked-cheater-readonly-details';
import { BlockedExamCenterManagerReadonlyDetails } from '../blocked-exam-center-manager-readonly-details';
import { BlockedExamPasserReadonlyDetails } from '../blocked-exam-passer-readonly-details';
import { BlockedStaffReadonlyDetails } from '../blocked-staff-readonly-details';

export default function BlockedRecordReadonlyDetails() {
  const {
    blockedRecord: { blockedType },
  } = useBlockedRecordDetails();

  switch (blockedType) {
    case BlockedRecordBlockedType.ExamPasser:
      return <BlockedExamPasserReadonlyDetails />;
    case BlockedRecordBlockedType.Cheater:
      return <BlockedCheaterReadonlyDetails />;
    case BlockedRecordBlockedType.ExamCenterManager:
      return <BlockedExamCenterManagerReadonlyDetails />;
    default:
      return <BlockedStaffReadonlyDetails />;
  }
}
